import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import Grid from "@mui/material/Grid";

import React, { useEffect, useState } from "react";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";
import {} from "../../utils/utils";
// import Youtube from '../assets/img/icon/youtube.png'
import Youtube from "../../assets/img/icon/youtube.png";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ShareIcon from "@mui/icons-material/Share";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
// import { GetBussiness, UpdateBusiness } from "./myBusinessApi";

import AddLocationIcon from "@mui/icons-material/AddLocation";
import { formDataFN, swalAlertPopProps } from "../../utils/commonUtils";
// import { validationsSubmits } from "./myBusinessValidationFunctions";
import { FormGroup } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import ApModal from "../../common/AppoinmetModalppBtn";
import MediaModel from "../../common/mediaModel";
import MediaModelApp from "../../common/mediaModelApp";
import MediaCardInput from "../../common/mediaCardInput";
import PersonIcon from "@mui/icons-material/Person";
import { cityNameCll } from "../landingPage/landingPageApi";
import ImageUploader from "../../common/imageUpload";
import { formDataFn } from "../../common/commonUtils/commonUtilFunction";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import MultipleImageInput from "../../common/imgUploadMul";
import { GetBussiness, UpdateBusiness } from "../myBusiness/myBusinessApi";
import { validationsSubmits } from "../myBusiness/myBusinessValidationFunctions";
import {
  getInstitute,
  institueAdd,
  institueUpdate,
} from "../myInstitute/instituteApi";
import { franchiseAdd, franchiseUpdate, getFranchise } from "./franchiseAPI";
// import { getInstitute, institueAdd, institueUpdate } from "./instituteApi";

export default function FranchiseInformation(instituteId) {
  const struct = {
    // id: 4,
    billerId: 0,
    logo: null,
    profileId: null,
    brandName: "",
    companyName: "",
    briefAddress: "",
    state: "",
    district: "",
    city: "",
    pincode: null,
    area: "",
    latitude: 0,
    longitude: 0,
    emailId1: null,
    emailId2: null,
    mobileNumber1: "",
    mobileNumber2: null,
    whatsappNumber: "",
    google: "",
    website: "",
    instagram: "",
    facebook: null,
    youTube: null,
    pinterest: null,
    twitter: null,
    linkedIn: null,
    image1: "",
    image2: "",
    image3: "",
    image4: "",
    image5: "",
    image6: "",
    lastModifiedDate: "",
  };

  const [franchise, setFranchise] = useState({ ...struct });
  const [selectedImages, setSelectedImages] = useState([]);

  const [hide, setHide] = useState(false);

  const userDetail = useSelector((state) => state.reducer.userDetail);

  let val = userDetail?.profileId?.split("?")[1];
  let billerId = Number(val?.split("=")[1]?.replace(/\D/g, ""));

  const getData = async () => {
    const payload = { billerId: billerId || userDetail?.userMasterId };

    getFranchise(payload, (res) => {
      const obj = res?.data?.data?.list?.[0];
      if (!obj) {
        // NO DATA → RESET FORM FOR ADD
        setFranchise({ ...struct, billerId });
        setSelectedImages([]);
        return;
      }

      setSelectedImages([]);
      setFranchise(obj);

      // console.log(obj);
    });

    // console.log("ll", franchise?.brandName);
  };

  function optionVal(data) {
    if (!data) return "";

    const dataColl = [
      "google",
      "website",
      "instagram",
      "facebook",
      "youTube",
      "pinterest",
      "twitter",
      "linkedIn",
    ];

    const selected = dataColl.filter((key) => data[key]);
    return selected.length ? selected.join(", ") : " ";
  }

  const submit = async () => {
    let obj = {
      Id: franchise?.id || 0,
      BillerId: billerId,
      //  File: franchise.File,
      ProfileId: franchise.profileId,

      brandName: franchise.brandName,
      companyName: franchise.companyName,
      BriefAddress: franchise.briefAddress,
      State: franchise.state,
      District: franchise.district,
      City: franchise.city,
      Pincode: franchise.pincode,
      Area: franchise.area,

      Latitude: franchise.latitude,
      Longitude: franchise.longitude,

      EmailId1: franchise.emailId1,
      EmailId2: franchise.emailId2,
      MobileNumber1: franchise.mobileNumber1,
      MobileNumber2: franchise.mobileNumber2,
      WhatsappNumber: franchise.whatsappNumber,

      Google: franchise.google,
      Website: franchise.website,
      Instagram: franchise.instagram,
      Facebook: franchise.facebook,
      YouTube: franchise.youTube,
      Pinterest: franchise.pinterest,
      Twitter: franchise.twitter,
      LinkedIn: franchise.linkedIn,
      //  File: selectedImages,
    };
    // selectedImages.forEach((ele, index) => {
    //   obj["File" + (index == 0 ? "" : index + 1)] = ele.file
    //     ? ele.file
    //     : ele.url;
    // });
    selectedImages.forEach((ele, index) => {
      obj[`File${index + 1}`] = ele.file ? ele.file : ele.url;
    });

    if (franchise.LogoFile instanceof File) {
      obj.LogoFile = franchise.LogoFile;
    }

    let payload = formDataFN(obj);

    if (!franchise?.id) {
      await franchiseAdd(payload, () => {
        getData();
      });
    } else {
      await franchiseUpdate(payload, () => {
        getData();
      });
    }
  };
  useEffect(() => {
    getData();
  }, []);
  // return <h1>fet</h1>
  return (
    <Grid
      container
      px={{ sm: 4, xs: 2 }}
      pb={4}
      sx={{
        paddingTop: "15px",
        backgroundColor: "#E3E3FF",
        minHeight: "100vh",
      }}
    >
      {/* <DynamicBreadcrumbs /> */}

      <Grid item xs={12}>
        <Grid container>
          <Grid
            item
            xs={12}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px 15px",
              mt: { sm: "10px", xs: "1px" },
              borderRadius: "5px",
              color: "#01008B", // optional text color
              textAlign: "left",
              marginBottom: "20px",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },

              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: "13px", sm: "14px", md: "20px" },
              }}
            >
              Franchise Information{" "}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={1}
          sx={{
            margin: 0,
            padding: { xs: "0px", sm: "20px" },
            borderRadius: "10px",
            backgroundColor: "#fff",
            maxHeight: "80vh",
            overflow: "auto",
            pr: { xs: 1, sm: 4 },
          }}
        >
          <Grid item xs={12}>
            <Grid container spacing={1}>
              {/* ...Left side */}
              <Grid
                item
                xs={12}
                sm={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {franchise?.logoPreview ? (
                    // ✅ NEW IMAGE PREVIEW
                    <Box
                      component="img"
                      src={franchise.logoPreview}
                      alt="Preview"
                      onClick={() =>
                        document.getElementById("imageUpload").click()
                      }
                      sx={{
                        width: { xs: "100px", sm: "150px" },
                        height: { xs: "100px", sm: "150px" },
                        cursor: "pointer",
                        // borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  ) : franchise?.logo ? (
                    // ✅ EXISTING IMAGE FROM API
                    <Box
                      component="img"
                      src={franchise.logo}
                      alt="Existing"
                      onClick={() =>
                        document.getElementById("imageUpload").click()
                      }
                      sx={{
                        width: { xs: "100px", sm: "150px" },
                        height: { xs: "100px", sm: "150px" },
                        cursor: "pointer",
                        // borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    // ✅ NO IMAGE
                    <Button
                      variant="outlined"
                      endIcon={<AddAPhotoOutlinedIcon />}
                      onClick={() =>
                        document.getElementById("imageUpload").click()
                      }
                    >
                      Attach Image
                    </Button>
                  )}

                  <input
                    type="file"
                    id="imageUpload"
                    style={{ display: "none" }}
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (file) {
                        setFranchise((prev) => ({
                          ...prev,
                          LogoFile: file,
                          logoPreview: URL.createObjectURL(file), // ✅ THIS drives preview
                        }));
                      }
                    }}
                  />
                </Box>
                <Box>
                  {/* Inline MediaCardInput component */}

                  <Button
                    variant="contained"
                    size="small"
                    onClick={() =>
                      document.getElementById("imageUpload").click()
                    }
                    sx={{
                      marginTop: "15px",
                      padding: "10px 40px",
                      height: "40px",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    Add Logo
                  </Button>
                </Box>
              </Grid>
              {/* Right side */}
              <Grid item xs={12} sm={9}>
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      id="brandName"
                      size="small"
                      label="Institute Name"
                      value={franchise?.brandName}
                      onChange={(e) => {
                        setFranchise({
                          ...franchise,
                          brandName: e.target.value,
                        });
                      }}
                      InputLabelProps={{
                        sx: {
                          // color: "#545454",
                          // fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // fontWeight: 500,
                        },
                      }}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      id="companyName"
                      label="Branch Name"
                      size="small"
                      value={franchise?.companyName}
                      onChange={(e) => {
                        setFranchise({
                          ...franchise,
                          companyName: e.target.value,
                        });
                      }}
                      InputLabelProps={{
                        sx: {
                          // color: "#545454",
                          // fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // fontWeight: 500,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <TextField
                      fullWidth
                      id="BrifeAddress"
                      // label="Brief Address"
                      label={
                        <span>
                          Brief Address <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      size="small"
                      // value={franchise?.address}
                      value={
                        franchise?.briefAddress == null ||
                        franchise?.briefAddress === "null"
                          ? ""
                          : franchise.briefAddress
                      }
                      onChange={(e) => {
                        setFranchise({
                          ...franchise,
                          briefAddress: e.target.value,
                        });
                      }}
                      InputLabelProps={{
                        sx: {
                          // color: "#545454",
                          // fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // fontWeight: 500,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item md={6} xs={6}>
                    <TextField
                      fullWidth
                      id="state"
                      size="small"
                      label="State"
                      value={
                        franchise?.state == null || franchise?.state === "null"
                          ? ""
                          : franchise.state
                      }
                      onChange={(e) => {
                        setFranchise({
                          ...franchise,
                          state: e.target.value,
                        });
                      }}
                      InputLabelProps={{
                        sx: {
                          // color: "#545454",
                          // fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // fontWeight: 500,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item md={6} xs={6}>
                    <TextField
                      fullWidth
                      id="district"
                      label="District"
                      size="small"
                      // value={franchise?.district}
                      value={
                        franchise?.district == null ||
                        franchise?.district === "null"
                          ? ""
                          : franchise.district
                      }
                      onChange={(e) => {
                        setFranchise({
                          ...franchise,
                          district: e.target.value,
                        });
                      }}
                      InputLabelProps={{
                        sx: {
                          // color: "#545454",
                          // fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // fontWeight: 500,
                        },
                      }}
                    />
                  </Grid>

                  <Grid item md={4} xs={4}>
                    <TextField
                      fullWidth
                      id="city"
                      size="small"
                      label="City"
                      // value={franchise?.city}
                      value={
                        franchise?.city == null || franchise?.city === "null"
                          ? ""
                          : franchise.city
                      }
                      onChange={(e) => {
                        setFranchise({
                          ...franchise,
                          city: e.target.value,
                        });
                      }}
                      InputLabelProps={{
                        sx: {
                          // color: "#545454",
                          // fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // fontWeight: 500,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item md={4} xs={6}>
                    <TextField
                      fullWidth
                      id="pincode"
                      size="small"
                      label="Pincode"
                      // value={franchise?.pincode}
                      value={
                        franchise?.pincode == null ||
                        franchise?.pincode === "null"
                          ? ""
                          : franchise.pincode
                      }
                      onChange={(e) => {
                        setFranchise({
                          ...franchise,
                          pincode: e.target.value,
                        });
                      }}
                      InputProps={{
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // fontWeight: 500,
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          // color: "#545454",
                          // fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // paddingX: "7px",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      fullWidth
                      id="area"
                      size="small"
                      // label="Area"
                      InputLabelProps={{
                        sx: {
                          // color: "#545454",
                          // fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // paddingX: "7px",
                        },
                      }}
                      label={
                        <span>
                          Area <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      // value={franchise?.area}
                      value={
                        franchise?.area == null || franchise?.area === "null"
                          ? ""
                          : franchise.area
                      }
                      onChange={(e) => {
                        setFranchise({
                          ...franchise,
                          area: e.target.value,
                        });
                      }}
                      InputProps={{
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // fontWeight: 500,
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={3} xs={6}>
            <TextField
              fullWidth
              id="latitude"
              label="Latitude"
              size="small"
              // value={franchise?.latitude}
              value={
                franchise?.latitude == null || franchise?.latitude === "null"
                  ? ""
                  : franchise.latitude
              }
              onChange={(e) => {
                // setFranchise({
                //   ...franchise,
                //   latitude: e.target.value,
                // });
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
              readOnly={true}
            />
          </Grid>
          <Grid item md={3} xs={6}>
            <TextField
              fullWidth
              id="longitude"
              label="Longitude"
              size="small"
              // value={franchise?.longitude}
              value={
                franchise?.longitude == null || franchise?.longitude === "null"
                  ? ""
                  : franchise.longitude
              }
              onChange={(e) => {
                // setFranchise({
                //   ...franchise,
                //   longitude: e.target.value,
                // });
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
              readOnly={true}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Button
              sx={{
                height: "40px",
                width: { sm: "50%", xs: "100%" },
                fontFamily: "'Montserrat', sans-serif",
                fontSize: { xs: "12px", sm: "13px", md: "16px" },

                display: "flex",
                justifyContent: "space-between",
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
              onClick={() => {
                cityNameCll((data) => {
                  console.log("location", data);
                  setFranchise((prev) => {
                    let temp = { ...prev };
                    temp.longitude = data?.lon;
                    temp.latitude = data?.lat;
                    console.log("temp", temp);
                    return {
                      ...temp,
                      mobileNumber: userDetail?.mobileNumber,
                    };
                  });
                  // asignCityName(data?.city)
                  // setCurrentLocation(data?.city)
                  // dispatch(setNavBarInputFields({location:data?.city}))
                });
              }}
              variant="contained"
              endIcon={<AddLocationIcon />}
            >
              Set Location
            </Button>
          </Grid>

          <Grid item md={4} xs={12}>
            <TextField
              fullWidth
              id="emailId1"
              size="small"
              label="Email Id"
              // value={franchise?.mailID1}
              value={
                franchise?.emailId1 == null || franchise?.emailId1 === "null"
                  ? ""
                  : franchise.emailId1
              }
              onChange={(e) => {
                setFranchise({
                  ...franchise,
                  emailId1: e.target.value,
                });
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <TextField
              fullWidth
              id="emailId2"
              label="Email Id"
              size="small"
              // value={franchise?.mailID2}
              value={
                franchise?.emailId2 == null || franchise?.emailId2 === "null"
                  ? ""
                  : franchise.emailId2
              }
              onChange={(e) => {
                setFranchise({
                  ...franchise,
                  emailId2: e.target.value,
                });
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <TextField
              fullWidth
              id="mobileNumber1"
              // label="Mobile Number"
              label={
                <span>
                  Mobile Number <span style={{ color: "red" }}>*</span>
                </span>
              }
              size="small"
              InputProps={{
                // readOnly: true,
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  setFranchise({
                    ...franchise,
                    mobileNumber1: value,
                  });
                }
              }}
              // value={userDetail?.mobileNumber}
              value={
                franchise?.mobileNumber1 == null ||
                franchise?.mobileNumber1 === "null"
                  ? ""
                  : franchise.mobileNumber1
              }
            />
          </Grid>

          <Grid item md={4} xs={12}>
            <TextField
              fullWidth
              id="mobileNumber2"
              label="Alternate Mobile Number"
              size="small"
              // value={franchise?.mobileNumber2}
              value={
                franchise?.mobileNumber2 == null ||
                franchise?.mobileNumber2 === "null"
                  ? ""
                  : franchise.mobileNumber2
              }
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  setFranchise({
                    ...franchise,
                    mobileNumber2: value,
                  });
                }
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
            />
          </Grid>

          <Grid item md={4} xs={12}>
            <TextField
              fullWidth
              id="whatsappNumber"
              label="Whatsapp Mobile Number"
              size="small"
              // value={franchise?.mobileNumber2}
              value={
                franchise?.whatsappNumber == null ||
                franchise?.whatsappNumber === "null"
                  ? ""
                  : franchise.whatsappNumber
              }
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  setFranchise({
                    ...franchise,
                    whatsappNumber: value,
                  });
                }
              }}
              InputLabelProps={{
                sx: {
                  // color: "#545454",
                  // fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  // fontWeight: 500,
                },
              }}
            />
          </Grid>

          <Grid item md={4} xs={12}>
            <FormControl
              fullWidth
              size="small"
              onClick={() => {
                setHide(true);
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: "40px",
                },
              }}
            >
              <InputLabel id="tags-label" className="mulish">
                Social Media Link
              </InputLabel>
              <Select
                labelId="tags-label"
                id="businessCategory"
                readOnly={true}
                name="businessCategory"
                value={optionVal(franchise)}
                onChange={(e) => {
                  setFranchise({
                    ...franchise,
                    serviceTo: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  },
                }}
                input={
                  <OutlinedInput
                    label="Social Media Link"
                    sx={{
                      height: "40px", // same as TextField small
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      "& .MuiOutlinedInput-input": {
                        padding: "8.5px 14px", // key line
                      },
                    }}
                  />
                }
              >
                <MenuItem value={optionVal(franchise)}>
                  <ListItemText
                    primary={optionVal(franchise)}
                    primaryTypographyProps={{
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      fontFamily: "Montserrat",
                    }}
                  />
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "60%",
                mx: "auto",
              }}
            >
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={submit}
                sx={{
                  mt: 3,
                  mb: 2,
                  py: 1,
                  fontSize: { xs: "12px", sm: "13px", md: "16px" },
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                }}
              >
                Save
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>

      {/* <ApModal open={} setOpen={} /> */}
      {franchise != null && (
        <MediaModelApp
          open={hide}
          setOpen={setHide}
          modelData={{
            google: "",
            website: "",
            instagram: "",
            facebook: "",
            youTube: "",
            pinterest: "",
            twitter: "",
            linkedIn: "",
            ...franchise,
          }}
          setModalData={setFranchise}
        />
      )}
    </Grid>
  );
}
